module.exports = __webpack_public_path__ + "static/img/wnat.7d093f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/wnat.png
// module id = dLPq
// module chunks = 18